import { ApiResponse, fetchApi, PaginationRequest, PaginationResponse } from './common';
import { TreatmentRecord, TreatmentRecordComment, TreatmentVisibility } from './model';

// 治疗记录相关接口定义
// 已在 model.ts 中定义，此处不再重复定义

// 治疗记录评论接口定义
// 已在 model.ts 中定义，此处不再重复定义

// 创建治疗记录请求接口
export interface CreateTreatmentRecordRequest {
  patient_id: string;
  type_id: number;
  treatment_date: string;
  visibility: string;
  content: string;
}

// 更新治疗记录请求接口
export interface UpdateTreatmentRecordRequest {
  type_id?: number;
  treatment_date?: string;
  visibility?: TreatmentVisibility;
  content?: string;
}

// 添加治疗记录评论请求接口
export interface AddTreatmentRecordCommentRequest {
  content: string;
}

// 获取治疗记录列表响应接口
export type ListTreatmentRecordsResponse = PaginationResponse<TreatmentRecord>;

// 治疗可见性枚举
// 已在 model.ts 中定义，此处不再重复定义

// 治疗记录API请求函数
export const treatmentApi = {
  // 获取患者治疗记录
  getTreatmentRecordsByPatientID: async (
    patientId: string,
    params?: PaginationRequest
  ): Promise<ApiResponse<ListTreatmentRecordsResponse>> => {
    const url = new URL(
      `/api/doctor_view/patients/${patientId}/treatment_records`,
      window.location.origin
    );
    if (params) {
      Object.keys(params).forEach((key) => {
        const value = params[key as keyof PaginationRequest];
        if (value !== undefined) {
          url.searchParams.append(key, value.toString());
        }
      });
    }
    return fetchApi<ListTreatmentRecordsResponse>(url.toString(), 'GET');
  },

  // 创建治疗记录
  createTreatmentRecord: async (
    data: CreateTreatmentRecordRequest
  ): Promise<ApiResponse<TreatmentRecord>> =>
    fetchApi<TreatmentRecord>('/api/doctor_view/treatment_records', 'POST', data),

  // 更新治疗记录
  updateTreatmentRecord: async (
    recordId: string,
    data: UpdateTreatmentRecordRequest
  ): Promise<ApiResponse<TreatmentRecord>> =>
    fetchApi<TreatmentRecord>(
      `/api/doctor_view/treatment_records/${recordId}`,
      'PUT',
      data
    ),

  // 删除治疗记录
  deleteTreatmentRecord: async (
    recordId: string
  ): Promise<ApiResponse<null>> =>
    fetchApi<null>(`/api/doctor_view/treatment_records/${recordId}`, 'DELETE'),

  // 添加治疗记录评论
  addTreatmentRecordComment: async (
    recordId: string,
    data: AddTreatmentRecordCommentRequest
  ): Promise<ApiResponse<TreatmentRecordComment>> =>
    fetchApi<TreatmentRecordComment>(
      `/api/doctor_view/treatment_records/${recordId}/comments`,
      'POST',
      data
    ),
};